import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M4.222 5L4 3h12l-.222 2h-1.006l.111-1H5.117l.111 1H4.222zM2 6l.444 2h1.024l-.222-1h13.507l-.222 1h1.024l.444-2h-16zM1 9l2 9h14l2-9H1zm11.75 3h-5.5L7 11h6l-.25 1z',
  ],
  height: 20,
  width: 20,
});
